import { render, staticRenderFns } from "./header-profile.vue?vue&type=template&id=9faeefda&"
import script from "./header-profile.vue?vue&type=script&lang=js&"
export * from "./header-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports